import moment from "moment";

const jexcel = require('jexcel');

$(document).ready(function () {
    let client_select = $("#history-filters .hf-client select");
    let market_select = $("#history-filters .hf-market select");

    client_select.select2();
    market_select.select2();

    const baseUrl = $("#app_url").val();

    let ads_leads = {
        table: $('#ads-leads-table'),
        import: null,
        header: [],
        rows: [],
        core: [],
        sorts: {},
        changes: {
            updated: [],
            created: [],
            deleted: []
        },
        future_index: 1
    };

    let generate = () => {
        $.ajax({
            type: 'POST',
            url: baseUrl + 'history/ads-leads',
            data: {
                import_id: ads_leads.table.data('import_id')
            },
            beforeSend: function () {
                $('#ads-leads-loader').fadeIn();
                $('#ads-leads-back').attr('disabled', 'disabled');
                $('#ads-leads-create').attr('disabled', 'disabled');
                $('#ads-leads-save').attr('disabled', 'disabled');
            },
            success: function (data) {
                ads_leads.import = data["import"];
                ads_leads.header = data["header"];
                ads_leads.rows = JSON.parse(JSON.stringify(data["rows"]));
                ads_leads.core = JSON.parse(JSON.stringify(data["rows"]));
                ads_leads.sorts = {};
                ads_leads.changes = {
                    updated: [],
                    created: [],
                    deleted: []
                };

                if (ads_leads.core.length){
                    ads_leads.future_index = ads_leads.core[ads_leads.core.length - 1][0] + 1;
                } else {
                    ads_leads.future_index = 1;
                }

                displayAdsLeadsTable();
            },
            complete: function () {
                $('#ads-leads-loader').fadeOut();
                $('#ads-leads-back').removeAttr('disabled');
                $('#ads-leads-create').removeAttr('disabled');
            }
        });
    };

    if (ads_leads.table.length){
        generate();
    }

    let displayAdsLeadsTable = () => {
        let data = multiSort(JSON.parse(JSON.stringify(ads_leads.sorts)));

        jexcel.destroy(document.getElementById('ads-leads-table'), false);

        ads_leads.table.jexcel({
            lazyLoading: true,
            loadingSpin: true,
            columnSorting: true,
            tableOverflow: true,
            allowInsertColumn: false,
            allowDeleteColumn: false,
            allowInsertRow: true,
            allowDeleteRow: true,
            csvHeader: true,
            columns: ads_leads.header,
            data: data,
            onchange: actions,
            oninsertrow: insert,
            ondeleterow: deleteRow
        });

        setHeaderArrowsColor();
    };

    let setHeaderArrowsColor = () => {
        let tds = $('#ads-leads-table .jexcel > thead.resizable > tr > td');
        tds.removeClass('has_sorting_asc');
        tds.removeClass('has_sorting_desc');

        for (let column in ads_leads.sorts){
            if (ads_leads.sorts.hasOwnProperty(column)){
                let nth = +column + 2;
                let c = 1;
                tds.each(function () {
                    if (c === nth) {
                        $(this).addClass('has_sorting_' + ads_leads.sorts[column]);
                    }
                    c++;
                });
            }
        }
    };

    let withoutDollar = (string) => {
        let number = 0;
        if (typeof string === 'string') {
            number = string.split('$').join('').split(',').join('');
            number = isNaN(parseFloat(number)) ? 0 : parseFloat(number);
        } else if (typeof string === 'number') {
            number = string;
        }
        return number;
    };

    let multiSort = (sortObject = {}) => {
        let array = ads_leads.rows.concat(ads_leads.changes.created);

        const sortKeys = Object.keys(sortObject);

        // Return array if no sort object is supplied.
        if (!sortKeys.length) {
            return array;
        }

        // Change the values of the sortObject keys to -1, 0, or 1.
        for (let key in sortObject) {
            sortObject[key] = sortObject[key] === 'desc' || sortObject[key] === -1 ? -1 : (sortObject[key] === 'skip' || sortObject[key] === 0 ? 0 : 1);
        }

        const keySort = (a, b, direction) => {
            direction = direction !== null ? direction : 1;

            if (a === b) { // If the values are the same, do not switch positions.
                return 0;
            }

            // If b > a, multiply by -1 to get the reverse direction.
            return a > b ? direction : -1 * direction;
        };

        return array.sort((a, b) => {
            let sorted = 0;
            let index = 0;

            // Loop until sorted (-1 or 1) or until the sort keys have been processed.
            while (sorted === 0 && index < sortKeys.length) {
                const key = sortKeys[index];

                if (key) {
                    const direction = sortObject[key];

                    let varA = '';
                    let varB = '';

                    if (a.hasOwnProperty(key)){
                        if (a[key] === null){
                            varA = 0;
                            varB = 1;
                        }
                        else if (b[key] === null){
                            varA = 1;
                            varB = 0;
                        }
                        else if ([7, 8, 23].indexOf(+key) !== -1) {
                            varA = moment(a[key],"YYYY-MM-DD h:mm:ss");
                            varB = moment(b[key],"YYYY-MM-DD h:mm:ss");
                        }
                        else if ([9, 10, 11, 12, 16, 18, 19, 21, 22, 24, 25, 26, 31].indexOf(+key) !== -1) {
                            varA = a[key] ? a[key].toLowerCase() : '';
                            varB = b[key] ? b[key].toLowerCase() : '';
                        }
                        else if ([13, 14, 15, 17, 20, 27, 28, 29, 30].indexOf(+key) !== -1) {
                            varA = withoutDollar(a[key]);
                            varB = withoutDollar(b[key]);
                        }
                        else{
                            varA = a[key];
                            varB = b[key];
                        }
                    }

                    sorted = keySort(varA, varB, direction);
                    index++;
                }
            }

            return sorted;
        });
    };

    let saveToggle = () => {
        if (ads_leads.changes.updated.length || ads_leads.changes.created.length || ads_leads.changes.deleted.length){
            $('#ads-leads-save').removeAttr('disabled');
        } else{
            $('#ads-leads-save').attr('disabled', 'disabled');
        }
    };

    let actions = function (instance, cell, x, y, value) {
        if ([0, 1, 5, 6].indexOf(x) === -1){
            let index = +$('#ads-leads-table table tbody > tr[data-y="' + y + '"] > td[data-x="' + 0 + '"]').text();
            let status = $('#ads-leads-table table tbody > tr[data-y="' + y + '"] > td[data-x="' + 1 + '"]').text();

            // Plays
            if (+x === 2){
                value = isNaN(+value) || value === '1' ? 1 : null;
            }

            // Update default
            if (status === 'default'){
                ads_leads.rows.find(r => r[0] === index)[1] = 'updated';
                ads_leads.rows.find(r => r[0] === index)[x] = value;

                $('#ads-leads-table table tbody > tr[data-y="' + y + '"] > td[data-x="' + 1 + '"]').html(ads_leads.rows.find(r => r[0] === index)[1]);
                $('#ads-leads-table table tbody > tr[data-y="' + y + '"] > td[data-x="' + x + '"]').html(ads_leads.rows.find(r => r[0] === index)[x]);
            }

            // Update updated
            if (status === 'updated'){
                let row = JSON.parse(JSON.stringify(Object.values(ads_leads.rows.find(r => r[0] === index))));
                let core = JSON.parse(JSON.stringify(Object.values(ads_leads.core.find(c => c[0] === index))));

                row[1] = 'default';
                core[1] = 'default';

                row[x] = value;
                core[x] = value;

                let a = JSON.stringify(Object.values(row));
                let b = JSON.stringify(Object.values(core));

                ads_leads.rows.find(r => r[0] === index)[1] = a !== b ? 'updated' : 'default';
                ads_leads.rows.find(r => r[0] === index)[x] = value;

                $('#ads-leads-table table tbody > tr[data-y="' + y + '"] > td[data-x="' + 1 + '"]').html(ads_leads.rows.find(r => r[0] === index)[1]);
                $('#ads-leads-table table tbody > tr[data-y="' + y + '"] > td[data-x="' + x + '"]').html(ads_leads.rows.find(r => r[0] === index)[x]);
            }

            // Update created
            if (status === 'created'){
                ads_leads.changes.created.find(c => c[0] === index)[x] = value;

                $('#ads-leads-table table tbody > tr[data-y="' + y + '"] > td[data-x="' + x + '"]').html(ads_leads.changes.created.find(c => c[0] === index)[x]);
            }

            // Update changes updated
            ads_leads.changes.updated = ads_leads.rows.filter((r) => {
                return r[1] === 'updated';
            });

            saveToggle();
        }
    };

    let insert = function (instance, y, count, tds, before) {
        let top = before ? y : y + 1;

        let item = [
            ads_leads.future_index,
            'created',
            null,
            null,
            null,
            ads_leads.import.client['client_name'],
            ads_leads.import.market['market_id'],
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null,
            null
        ];

        ads_leads.future_index++;

        ads_leads.changes.created.push(item);

        for (let key in item){
            let td = $('#ads-leads-table table tbody > tr[data-y="' + top + '"] > td[data-x="' + key + '"]');

            if ([0, 1, 5, 6].indexOf(+key) === -1){
                td.removeClass('readonly');
            }

            td.html(item[key]);
        }

        saveToggle();
    };

    let deleteRow = function (el, rowNumber, numOfRows, rowRecords) {
        for (let key in rowRecords){
            if (rowRecords.hasOwnProperty(key)){
                let index = +rowRecords[key][0].innerHTML;
                let row = null;

                ads_leads.core.map((item) => {
                    if (item[0] === index){
                        row = item;
                    }
                });

                if (row !== null){
                    ads_leads.changes.deleted.push(row);
                } else {
                    ads_leads.changes.created = ads_leads.changes.created.filter((row) => {
                        return row[0] !== index;
                    });
                }
            }
        }

        let deleted_indexes = ads_leads.changes.deleted.map((row) => {
            return row[0];
        });

        ads_leads.core = ads_leads.core.filter((row) => {
            return deleted_indexes.indexOf(row[0]) === -1;
        });

        ads_leads.rows = ads_leads.rows.filter((row) => {
            return deleted_indexes.indexOf(row[0]) === -1;
        });

        ads_leads.changes.updated = ads_leads.changes.updated.filter((row) => {
            return deleted_indexes.indexOf(row[0]) === -1;
        });

        saveToggle();
    };

    // Create row
    $('#ads-leads-create').click(function () {
        ads_leads.table.jexcel('insertRow', [], 0, true);
    });

    // Back
    $('#ads-leads-back').click(function () {
        window.location.href = baseUrl + 'history';
    });

    // Sorting
    $('body').on('click', '#ads-leads-table .jexcel > thead.resizable > tr > td', function () {
        let column = parseInt($(this).data('x'));
        if (!isNaN(column)){
            if (ads_leads.sorts.hasOwnProperty(column)){
                if (ads_leads.sorts[column] === 'desc'){
                    delete ads_leads.sorts[column];
                } else{
                    ads_leads.sorts[column] = ads_leads.sorts[column] === 'asc' ? 'desc' : 'asc';
                }
            } else{
                ads_leads.sorts[column] = 'asc';
            }

            displayAdsLeadsTable();
        }
    });

    // Save
    $('#ads-leads-save').click(function () {
        $.ajax({
            type: 'POST',
            url: baseUrl + 'history/ads-leads-save',
            data: {
                changes: ads_leads.changes,
                import_id: ads_leads.import.id
            },
            beforeSend: function() {
                $('#ads-leads-back').attr('disabled', 'disabled');
                $('#ads-leads-create').attr('disabled', 'disabled');
                $('#ads-leads-save').attr('disabled', 'disabled');
                $('#ads-leads-save .fa').hide();
                $('#ads-leads-save .fa-spinner').show();
            },
            success: function (data) {
                if (data.success){
                    $('#ads-leads-errors').html('').hide();
                    $('#ads-leads-messages').html(data.message).show();
                    generate();
                } else{
                    $('#ads-leads-messages').html('').hide();
                    $('#ads-leads-errors').html(data.message).show();
                }
            },
            complete: function() {
                $('#ads-leads-save .fa').show();
                $('#ads-leads-save .fa-spinner').hide();
            }
        });
    });

    // Delete any imports
    let deleted_imports_ids = [];

    $('#history-table tbody tr td:first-child input').on('change', function () {
        let id = $(this).val();

        if (deleted_imports_ids.indexOf(id) === -1){
            deleted_imports_ids.push(id);
        } else {
            deleted_imports_ids = deleted_imports_ids.filter(i => i !== id);
        }

        updateDeletedImports();
    });

    $('#check-all-imports input').on('change', function () {
        let all = $(this);

        deleted_imports_ids = [];

        $('#history-table tbody tr td:first-child input').each(function () {
            if (all.is(':checked')){
                deleted_imports_ids.push($(this).val());
                $(this).prop('checked', true);
            } else {
                $(this).prop('checked', false);
            }
        });

        updateDeletedImports();
    });

    let updateDeletedImports = () => {
        if (deleted_imports_ids.length){
            $('#hdi-open').removeAttr('disabled');
        } else {
            $('#hdi-open').attr('disabled', 'disabled');
        }

        $('#hdi-form label input').val(deleted_imports_ids);
    };
});
